import React from 'react'

// Hooks
import { useCanvasZoom } from 'components/WebRendererCanvas/hooks'

// Local Components
import PublicationPageSelector from '../PublicationPageSelector'

// Styles
import { StyledZoom } from './PublicationCanvasControls.styles'

// Types
import { PublicationPageFragment } from '@sketch/gql-types'

interface PublicationCanvasControlsProps {
  identifier: string
  page: PublicationPageFragment
  onPageSelected: (page: PublicationPageFragment) => void
}

const PublicationCanvasControls: React.FC<PublicationCanvasControlsProps> = ({
  identifier,
  page,
  onPageSelected,
}) => {
  const [zoom, setZoom] = useCanvasZoom()

  return (
    <>
      <PublicationPageSelector
        identifier={identifier}
        page={page}
        onPageSelected={onPageSelected}
      />
      <StyledZoom zoom={zoom} setZoom={setZoom} />
    </>
  )
}

export default PublicationCanvasControls
